export interface ISuggestResult {
  name: string
  id: string
}

export interface IRequestState {
  results?: ISuggestResult[]
  loading: boolean
}

export interface IAutocompleteSearchResult {
  namesearch: ISuggestResult[]
}

export enum RequestType {
  request = 'REQUEST',
  success = 'SUCCESS',
}

export interface IRequestAction {
  type: RequestType
  payload?: ISuggestResult[]
}
